import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const AddModule = () => {
  const navigate = useNavigate();

  const handleAddModule = () => {
    navigate('/add-module-here');
  };

  const handleMapModule = () => {
    navigate('/map-module-to-degree');
  };

  const handleEditAddModule = () => {
    navigate('/edit-add-module');
  };

  const handleEditMapModule = () => {
    navigate('/edit-map-module');
  };

  // Button component with the same style as AcademicManagement
  const ActionButton = ({ title, onClick, iconType }) => (
    <div 
      style={{
        width: 310, 
        height: 160, 
        background: '#E5BD9E',
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12), 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04)', 
        borderRadius: 24,
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden',
        border: '2px solid none',
        transition: 'all 0.3s ease',
        marginBottom: '20px',
        transform: 'translateY(0)',
      }}
      onClick={onClick}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0px 12px 32px rgba(0, 0, 0, 0.16), 0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0px 8px 24px rgba(0, 0, 0, 0.12), 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04)';
      }}
    >
      {/* Background Icon */}
      <div style={{
        position: 'absolute',
        right: 20,
        top: 20,
        width: 74,
        height: 73,
        opacity: 0.5,
        zIndex: 1
      }}>
        <img 
          src={`/assets/icons/${iconType === 'map' ? 'icon2.svg' : iconType === 'edit-add' ? 'icon3.svg' : iconType === 'edit-map' ? 'icon4.svg' : 'icon1.svg'}`}
          alt=""
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>

      <div style={{
        padding: '36px 24px',
        color: '#D44311',
        fontSize: 22,
        fontFamily: 'Outfit',
        fontWeight: '700',
        lineHeight: '28px',
        position: 'relative',
        zIndex: 2
      }}>
        {title}
      </div>

      <div style={{
        width: 128,
        padding: '8px 32px',
        background: '#F04915',
        borderRadius: 25,
        position: 'absolute',
        left: 32,
        bottom: 26,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
        boxShadow: '0px 4px 16px rgba(240, 73, 21, 0.4)',
        transition: 'all 0.3s ease'
      }}>
        <div style={{
          color: 'white',
          fontSize: 28,
          fontFamily: 'Poppins',
          fontWeight: '600'
        }}>{iconType === 'edit-add' || iconType === 'edit-map' ? '✎' : '+'}</div>
      </div>
    </div>
  );

  return (
    <div style={{width: '100%', height: '100%', position: 'relative', background: 'white'}}>
      <Sidebar />
      
      <div style={{marginLeft: 290, width: 'calc(100% - 290px)', minHeight: '100vh'}}>
        <Header />
        
        {/* Page Title */}
        <h1 style={{fontSize: 24, fontFamily: 'Outfit', fontWeight: '700', marginTop: '20px', paddingLeft: '40px'}}>
          Module Management
        </h1>

        {/* Module Management Content Area */}
        <div style={{marginTop: '20px', margin: '20px 40px'}}>
          <div style={{background: '#F04915', padding: '20px', borderTopLeftRadius: 15, borderTopRightRadius: 15}}>
            <h2 style={{color: 'white', fontSize: 24, fontFamily: 'Outfit', fontWeight: '700', margin: 0}}>
              Module Management Dashboard
            </h2>
          </div>

          <div style={{
            background: '#FFFBF5', 
            padding: '40px',
            borderBottomLeftRadius: 15,
            borderBottomRightRadius: 15,
            minHeight: '400px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              textAlign: 'center',
              color: '#77838F',
              fontSize: 18,
              fontFamily: 'Outfit',
              fontWeight: '400',
              marginBottom: '40px'
            }}>
              <p style={{marginBottom: '10px'}}>Module Management Tools</p>
              <p style={{fontSize: 16, opacity: 0.7}}>
                Create, edit, and map modules to degree programs
              </p>
            </div>

            {/* Action Buttons - All four buttons in a 2x2 grid with consistent styling */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
              {/* First Row - Add Functions */}
              <div style={{ display: 'flex', gap: '40px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <ActionButton 
                  title="Add Module" 
                  onClick={handleAddModule}
                  iconType="add"
                />
                <ActionButton 
                  title="Map Module" 
                  onClick={handleMapModule}
                  iconType="map"
                />
              </div>

              {/* Second Row - Edit Functions */}
              <div style={{ display: 'flex', gap: '40px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <ActionButton 
                  title="Edit Add Module" 
                  onClick={handleEditAddModule}
                  iconType="edit-add"
                />
                <ActionButton 
                  title="Edit Map Module" 
                  onClick={handleEditMapModule}
                  iconType="edit-map"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div style={{display: 'flex', justifyContent: 'flex-start', margin: '40px', marginTop: '20px'}}>
          <Link to="/admin">
            <button 
              type="button" 
              style={{
                width: 269, 
                padding: '11px 20px', 
                background: '#F04915', 
                border: 'none', 
                borderRadius: 8, 
                color: 'white', 
                fontSize: 16, 
                fontFamily: 'Outfit', 
                fontWeight: '500', 
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#D63A0F';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#F04915';
              }}
            >
              Back to Dashboard
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AddModule;
